// messagingConfig.js
import { initializeApp } from "firebase/app";
import firebaseConfig from "../firebaseConfig";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { db } from "@/main";
import { doc, setDoc, updateDoc, deleteField } from "firebase/firestore";
import { getMessaging, getToken, deleteToken, onMessage } from "firebase/messaging";
import { Capacitor } from "@capacitor/core";
import { PushNotifications } from "@capacitor/push-notifications";
import router from "@/router";

const firebaseApp = initializeApp(firebaseConfig);

// 🔥 CORRECTION : getMessaging uniquement sur web
const messaging = !Capacitor.isNativePlatform() ? getMessaging(firebaseApp) : null;

const handleNotificationClick = (data) => {
    console.log("Données de notification reçues :", data);
    
    try {
        if (data.route === "/book-sms" && data.bookId) {
            router.push({
                name: "book-sms",
                params: { 
                    id: data.bookId,
                }
            });
        } else {
            router.push("/");
        }
    } catch (error) {
        console.error("Erreur lors de la navigation :", error);
        router.push("/");
    }
};

export const requestPermission = async () => {
    try {
        if (Capacitor.isNativePlatform()) {
            const permStatus = await PushNotifications.requestPermissions();

            if (permStatus.receive === "granted") {
                console.log("Permission de notification accordée.");

                await PushNotifications.register();

                PushNotifications.addListener("registration", async (token) => {
                    console.log("Token d'inscription reçu :", token.value);

                    const auth = getAuth();
                    const user = auth.currentUser;

                    if (user) {
                        const userId = user.uid;

                        await setDoc(
                            doc(db, "users", userId),
                            {
                                fcmToken: token.value,
                                isOnline: true,
                                notificationAccepted: true,
                            },
                            { merge: true }
                        );
                    } else {
                        console.log("Aucun Itilizatè connecté.");
                    }
                });

                PushNotifications.addListener("registrationError", (error) => {
                    console.error("Erreur lors de l'enregistrement :", error);
                });
            } else {
                console.error("Permission de notification refusée sur mobile.");
            }
        } else {
            if (!("Notification" in window)) {
                console.error("Ce navigateur ne supporte pas les notifications.");
                return;
            }

            const permission = await Notification.requestPermission();

            if (permission === "granted") {
                const currentToken = await getToken(messaging, {
                    vapidKey: "BEgXoJzxbYJD9BPs9rGOcMw4520RU3jnf80hqVvlsCx1l-kWFyVbVA78hJxYnieDLN6p3p2HnuxCoFtekZVXTMQ",
                });

                if (currentToken) {
                    console.log("Token reçu :", currentToken);

                    const auth = getAuth();
                    const user = auth.currentUser;

                    if (user) {
                        const userId = user.uid;

                        await setDoc(
                            doc(db, "users", userId),
                            {
                                fcmToken: currentToken,
                                isOnline: true,
                                notificationAccepted: true,
                            },
                            { merge: true }
                        );
                    } else {
                        console.log("Aucun Itilizatè connecté.");
                    }
                } else {
                    console.log("Pas de token disponible.");
                }
            } else if (permission === "denied") {
                console.error("L'Itilizatè a refusé les notifications.");
            } else {
                console.error("Les notifications sont bloquées.");
            }
        }
    } catch (error) {
        console.error("Erreur lors de la récupération du token :", error);
    }
};

export const removeTokenOnLogout = async () => {
    try {
        const auth = getAuth();
        const user = auth.currentUser;

        if (user) {
            const userId = user.uid;

            await updateDoc(doc(db, "users", userId), {
                fcmToken: deleteField(),
                isOnline: false,
            });

            // 🔥 CORRECTION : deleteToken uniquement sur web
            if (!Capacitor.isNativePlatform()) {
                await deleteToken(messaging);
            }
            console.log("Token supprimé avec succès.");
        }
    } catch (error) {
        console.error("Erreur lors de la suppression du token :", error);
    }
};

export const validateTokens = async () => {
    // 🔥 CORRECTION : validateTokens uniquement sur web
    if (Capacitor.isNativePlatform()) return;

    const auth = getAuth();

    onAuthStateChanged(auth, async (user) => {
        if (user) {
            const userId = user.uid;
            const token = await getToken(messaging);

            if (!token) {
                console.warn(`Le token pour l'Itilizatè ${userId} est invalide ou expiré.`);
                await updateDoc(doc(db, "users", userId), {
                    fcmToken: deleteField(),
                });
            }
        }
    });
};

if (Capacitor.isNativePlatform()) {
    PushNotifications.addListener("pushNotificationReceived", (notification) => {
        console.log("Notification reçue :", notification);
    });

    PushNotifications.addListener("pushNotificationActionPerformed", (action) => {
        console.log("Action de notification effectuée :", action);
        
        const notificationData = action.notification.data;
        
        if (notificationData) {
            handleNotificationClick(notificationData);
        }
    });
}

if (!Capacitor.isNativePlatform()) {
    onMessage(messaging, (payload) => {
        console.log("Message reçu en foreground :", payload);
        
        if (payload.notification) {
            const notification = new Notification(payload.notification.title, {
                body: payload.notification.body,
                icon: payload.notification.icon || '/favicon.ico',
                data: payload.data
            });
            
            notification.onclick = function(event) {
                event.preventDefault();
                window.focus();
                notification.close();
                
                if (payload.data) {
                    handleNotificationClick(payload.data);
                }
            };
        }
    });
}

export { messaging, handleNotificationClick };